import { Label } from '../../Interface/Response/Interest/Label';
import { LabelState } from '../../Store/Label/state';
import { RootState } from '../../Store';

import { useSelector } from 'react-redux';

interface LabelDTO {
    allLabels: Label[];
    activeLabel: Label | null;
}

const getFilteredLabels = (labels: Label[], withExistingCustomers: boolean, setFilter: boolean): Label[] => {
    if (!withExistingCustomers) {
        labels = labels.filter(label => !label.onlyExistingCustomers);
    }

    if (setFilter) {
        return labels.filter(label => label.hasSet);
    }

    return labels;
};

const getSortedLabels = (labels: Label[]): Label[] => [...labels].sort((a, b) => a.label.localeCompare(b.label));

const useGetLabels = (withExistingCustomers: boolean, setFilter = false): LabelDTO => {
    const { labels, activeLabel } = useSelector<RootState, LabelState>(state => state.label);

    return {
        allLabels: getFilteredLabels(getSortedLabels(labels), withExistingCustomers, setFilter),
        activeLabel,
    };
};

export default useGetLabels;
